import { isJaguar } from "@/utility/UserUtils";
import React, { useEffect, useState } from "react";

import Modal from "react-modal";
import Cookies from "universal-cookie";
import { useConfirm } from 'material-ui-confirm';
import { fetchAPI } from "@/utility/NetworkUtils";

import CircularProgress from '@mui/material/CircularProgress';
import { Tab } from '@mui/material';
import { 
  TabContext, 
  TabList, 
  TabPanel,
} from '@mui/lab';

const ItemLogModal = (props) => {
  const { item, open, onClose, user, onUpdate} = props
  const [ loading, setLoading ] = useState(false)
  const [ logs, setLogs ] = useState([])
  const [ eventHolds, setEventHolds ] = useState([])
  const [ eventItemFields, setEventItemFields ] = useState([])
  const [ tab, setTab ] = useState("1")

  const confirm = useConfirm();
  useEffect(() => {
    if(open) {
      loadLogs()
      loadEventHolds()
      loadManifestItems()
    }
  },[open])

  const loadEventHolds = async () => {
    
    fetchAPI(`/webapi/items/${item.id}/item_holds/history`, (json)=> {
      if (!json.errors) {
        setEventHolds(json.item_holds)
      } else {
        console.log({errors: json.errors})
      }
    });
  }

    const loadManifestItems = async () => {
    
    fetchAPI(`/webapi/items/${item.id}/event_item_fields_logs`, (json)=> {
      if (!json.errors) {
        setEventItemFields(json.logs)
      } else {
        console.log({errors: json.errors})
      }
    });
  }

  const loadLogs = async () => {
    setLoading(true)
    const cookies = new Cookies();
    const token = cookies.get("X-CSRF-Token");
    fetch(`/webapi/items/${item.id}/logs`, {
      method: 'GET',
      redirect: "manual",
      headers: {
        "X-CSRF-Token": token,
        "Content-Type": 'application/json'
      }
    })
      .then(response => {
        setLoading(false)
        return response.json();
      })
      .then(json => {
        if (json.error == null) {
          setLogs(json.logs)
        }
      })
  }

  const deleteLog = async (id) => {
    const {
      confirmed
    } = await confirm({
      description: "Are you sure you want to delete this log? This is NOT recommended unless you truly made a mistake. Doing this may make the inventory count less than zero."
    })

    if (confirmed) {
      fetchAPI(`/webapi/items/${item.id}/item_logs/${id}`, (json)=> {
        if (!json.errors) {
          loadLogs()
          onUpdate()
        } else {
          console.log({
            errors: json.errors
          })
        }
      }, {
        method: 'DELETE',
      })
    }
  }

  const renderLogTable = () => {
    if(loading) {
      return (
        <div style={{display: 'flex', justifyContent: 'center'}}>
          <CircularProgress />
        </div>
      )
    }
    return (
      <table className="table">
        <thead>
          <tr>
            <th className="delta-col">Δ</th>
            <th className="reason-col">Reason</th>
            <th className="reason-col">Event</th>
            <th className="notes-col">Notes</th>
            <th className="user-col">User</th>
            <th className="date-col">Date</th>
            {isJaguar(user) && <th className="delete-col">Actions</th>}
          </tr>
        </thead>
        <tbody>
          {logs.map((log, index) => {
            return (
              <tr key={index}>
                <td>{log.count}</td>
                <td>{log.reason}</td>
                <td>{log.event ? log.event.name : ""}</td>
                <td>{log.notes}</td>
                <td>{log.user ? log.user.first_name + " " + log.user.last_name : ""}</td>
                <td>
                  {new Date(log.created_at).toLocaleString(
                    [], 
                    {year: 'numeric', month: 'numeric', day: 'numeric', hour: '2-digit', minute:'2-digit'}
                  )}
                </td>
                {isJaguar(user) && <td><button className="btn btn-danger pull-right" onClick={() => deleteLog(log.id)}>Delete</button></td>}
              </tr>
            )
          })}
        </tbody>
      </table>
    )
  }

  const renderItemHolds = () => {
    if(loading) {
      return (
        <div style={{display: 'flex', justifyContent: 'center'}}>
          <CircularProgress />
        </div>
      )
    }
    return (
      <table className="table">
        <thead>
          <tr>
            <th className="delta-col">Reserved</th>
            <th className="reason-col">Status</th>
            <th className="reason-col">Event</th>
            <th className="notes-col">Start Date</th>
            <th className="user-col">End Date</th>
          </tr>
        </thead>
        <tbody>
          {(eventHolds||[]).sort((a,b)=> {
            return (new Date(a.event.start_date) - new Date(b.event.start_date))*-1
          }).map((hold, index) => {
            const event = (hold.event||{})
            return (
              <tr key={hold.id}>
                <td>{hold.total_count}</td>
                <td>{hold.status}</td>
                <td>{event.name}</td>
                <td>{event.start_date}</td>
                <td>{event.end_date}</td>
              </tr>
            )
          })}
        </tbody>
      </table>
    )
  }

  const handleTabChange = (event, newValue) => {
    setTab(newValue);
  };

  const renderTabs = () => {
    return(
      <TabList onChange={handleTabChange} aria-label="lab API tabs example">
        <Tab label="Inventory History" value="1" />
        <Tab label="Event Holds" value="2" />
        <Tab label="Event Manifest History" value="3" />
      </TabList>
    )
  }

  const renderManifestTable = () => {
    if(loading) {
      return (
        <div style={{display: 'flex', justifyContent: 'center'}}>
          <CircularProgress />
        </div>
      )
    }
    return (
      <table className="table">
        <thead>
          <tr>
            <th> Event</th>
            <th className="reason-col">Returned</th>
            <th className="notes-col">Damaged</th>
            <th className="reason-col">Lost or Consumed</th>
            <th className="">Added On Site</th>
            <th>Notes</th>
          </tr>
        </thead>
        <tbody>
          {eventItemFields.map((log, index) => (
            <tr>
              <td>{log.event ? log.event.name : ""}</td>
              <td>{log.warehouse_received||0}</td>
              <td>{log.damaged||0}</td>
              <td>{log.lost_or_consumed||0}</td>
              <td>{log.extra}</td>
              <td>{log.post_event_notes}</td>
            </tr>
          ))}
        </tbody>
      </table>
    )
  }

  const renderBodies = () => {
    return(
      <>
        <TabPanel value="1">
          {renderLogTable()}
        </TabPanel>
        <TabPanel value="2">
          {renderItemHolds()}
        </TabPanel>
        <TabPanel value="3">
          {renderManifestTable()}
        </TabPanel>
      </>
    )
  }
  return (
    <Modal
      isOpen={open}
      onRequestClose={onClose}
      className="react-modal inventory-modal add-form-modal"
      overlayClassName="react-modal-overlay"
    >
      <TabContext value={tab}>
        {renderTabs()}
        {renderBodies()}
      </TabContext>
    </Modal>
  )
}

export default ItemLogModal